import { ApiService } from "src/app/services/api.service";
import { SignalRService } from "./services/signalr.service";
import jwtDecode  from "jwt-decode";
import { AccountService } from "src/app/services/account.service";
import { GridsterService } from "./services/gridster.service";
import { AfterViewInit, Component, ElementRef } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { GridsterItem } from "angular-gridster2";
import { UrlConstants } from "./models/urlConstants";
import { ActivatedRoute, Router } from "@angular/router";
import { InactivityService } from "./services/inactivity.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements AfterViewInit {
  title = "streamer-trading";
  companyName = UrlConstants.companyName;
  isEGID = UrlConstants.isEGID;
  lang: string = localStorage.getItem("lang") || "en";
  hideNavbar = false
  private dashboard: Array<GridsterItem>[] = [
    [
      {
        cols: 14,
        rows: 7,
        y: 0,
        x: 0,
        dragEnabled: true,
        resizeEnabled: true,
        name: "market-watch",
        state: "Most Active",
      },
      {
        cols: 8,
        rows: 7,
        y: 0,
        x: 22,
        dragEnabled: true,
        resizeEnabled: true,
        name: "market-news",
      },
      {
        cols: 8,
        rows: 7,
        y: 0,
        x: 14,
        dragEnabled: true,
        resizeEnabled: true,
        name: "market-trades",
      },
      {
        cols: 15,
        rows: 6,
        x: 0,
        y: 7,
        dragEnabled: true,
        resizeEnabled: true,
        name: "order-book",
      },
      {
        cols: 7,
        rows: 6,
        x: 15,
        y: 7,
        dragEnabled: true,
        resizeEnabled: true,
        name: "market-depth",
        isLinked: true,
      },
      {
        cols: 8,
        rows: 6,
        x: 22,
        y: 7,
        dragEnabled: true,
        resizeEnabled: true,
        name: "historical",
      },
      {
        cols: 6,
        rows: 6,
        y: 13,
        x: 6,
        dragEnabled: true,
        resizeEnabled: true,
        name: "depth-asks",
      },
      {
        cols: 6,
        rows: 6,
        y: 13,
        x: 0,
        dragEnabled: true,
        resizeEnabled: true,
        name: "depth-bids",
      },
      {
        cols: 9,
        rows: 6,
        y: 13,
        x: 12,
        dragEnabled: true,
        resizeEnabled: true,
        name: "news",
      },
    ],
  ];
  private notMarketDashboard: Array<GridsterItem[]> = [
    [
      {
        cols: 14,
        rows: 7,
        y: 0,
        x: 0,
        dragEnabled: true,
        resizeEnabled: true,
        name: "market-watch",
        state: "Most Active",
      },
      {
        cols: 8,
        rows: 7,
        y: 0,
        x: 22,
        dragEnabled: true,
        resizeEnabled: true,
        name: "news",
      },
      {
        cols: 8,
        rows: 7,
        y: 0,
        x: 14,
        dragEnabled: true,
        resizeEnabled: true,
        name: "trades",
      },
      {
        cols: 15,
        rows: 6,
        x: 0,
        y: 7,
        dragEnabled: true,
        resizeEnabled: true,
        name: "order-book",
      },
      {
        cols: 7,
        rows: 6,
        x: 15,
        y: 7,
        dragEnabled: true,
        resizeEnabled: true,
        name: "market-depth",
        isLinked: true,
      },
      {
        cols: 8,
        rows: 6,
        x: 22,
        y: 7,
        dragEnabled: true,
        resizeEnabled: true,
        name: "historical",
      },
    ],
  ];

  constructor(
    public translate: TranslateService,
    private gridService: GridsterService,
    public accService: AccountService,
    private elementRef: ElementRef,
    private router: Router,
    private route: ActivatedRoute,
     private inactivityService: InactivityService
  ) {
    let pageTabTitle = document.head.getElementsByTagName(
      "title"
    )[0] as HTMLElement;
    pageTabTitle.innerText = this.companyName;

    this.getZoomValue();
    translate.addLangs(["en", "ar"]);

    if (this.gridService.getLang() != null) {
      translate.use(this.gridService.getLang());
      translate.setDefaultLang(this.gridService.getLang());
    } else {
      translate.use("ar");
      translate.setDefaultLang("ar");
    }

    if (this.gridService.getGrid() == null) {
      this.accService.isFullMarketUser.subscribe((isMarket) => {
        if (isMarket) this.gridService.saveGrid(this.dashboard);
        else if (!isMarket) this.gridService.saveGrid(this.notMarketDashboard);
      });
    }

    if (this.gridService.getGrid() == null)
      this.accService.isFullMarketUser.subscribe((isMarket) => {
        if (isMarket) this.gridService.saveGrid(this.dashboard);
        else if (!isMarket) this.gridService.saveGrid(this.notMarketDashboard);
      });

    this.gridService.getGrid().forEach((element) => {
      if (element.length == null) this.gridService.saveGrid(this.dashboard);
    });

    accService.user.subscribe((token) => {
      if (token) {
        var decoded = jwtDecode(token.toString());

        let isMarket = decoded["unique_name"].split("_")[3];

        let isDemo = decoded["unique_name"].split("_")[4];

        if (isMarket == "1")
          //set is Market
          this.accService.setIsFullMarket(true);
        //set not is Market
        else if (isMarket == "0") this.accService.setIsFullMarket(false);
      }
    });
    this.router.events.subscribe(() => {
      // Check for the hideNavbar query parameter
      this.route.queryParams.subscribe((params) => {
        this.hideNavbar = params['hideNavbar'] === 'true'
      })
    })
  }
  ngOnInit(): void {
    let html = document.querySelector("html");
    let lang: string = localStorage.getItem("lang") || "en";
    html?.setAttribute("dir", lang == "en" ? "ltr" : "rtl");
    html?.setAttribute("lang", lang == "en" ? "en" : "ar");
    if (window.self !== window.top) {
      document.body.innerHTML = ''; // Show blank page
    }
  }

  getZoomValue() {
    let zoomPercent = `${localStorage.getItem("fontsize")}%`;
    this.elementRef.nativeElement.ownerDocument.body.style.zoom = zoomPercent;
  }
  ngAfterViewInit(): void {
    if (this.gridService.isDarkTheme == true) {
      this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor =
        " #131722";
    } else {
      this.elementRef.nativeElement.ownerDocument.body.style.backgroundColor =
        " #fff";
    }
  }

  isFullMarket(val) {
    return val.slice(val.indexOf("_") + 1) == 1;
  }

  // @HostListener("window:beforeunload")
  // unloadHandler(event) {
  //   this.accService.logout()
  // }
}
